module.exports = __webpack_public_path__ + "img/face_with_tears_of_joy.2156315f.gif";